import { SourceType } from '@travelity/api';
import { Select } from '@travelity/form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SelectReferral from '@components/select-company/select-referral';
import type { PackageBookingFormValues } from '../../package-form.helpers';
import { directSources, sourceTypes } from '../../../booking-side-form';

interface PackageBookingSourceSelectionProps {
    productId?: string;
}

const PackageBookingSourceSelection = ({
    productId,
}: PackageBookingSourceSelectionProps) => {
    const { t } = useTranslation('product');
    const { watch } = useFormContext<PackageBookingFormValues>();

    return (
        <>
            <Select
                name="sourceType"
                label={t('Booking Source Type')}
                placeholder={t('Select Source Type')}
                options={sourceTypes}
            />

            {watch('sourceType') === SourceType.DIRECT ? (
                <Select
                    name="sourceName"
                    label={t('Booking Source')}
                    placeholder={t('Select Source')}
                    options={directSources}
                />
            ) : (
                <SelectReferral
                    name="referral"
                    label={t('Booking Source')}
                    placeholder={t('Type company, email or name')}
                    productId={productId}
                />
            )}
        </>
    );
};

export default PackageBookingSourceSelection;
